import { LoginService } from './../../../core/services/login.service';
import { combineLatest } from 'rxjs';
import { Injectable } from '@angular/core';
import { gql, Apollo } from 'apollo-angular';
import { pluck } from 'rxjs/operators';

const secondHandSuppliesQuery = gql`query second_hand_supplies(
  $user_id:uuid!,
  $limit: Int,
  $offset: Int){
  second_hand_supplies(
    where:{
      second_hand_supplies_bids :{
      _or: [
      {
        dental_practice_id: {_eq: $user_id }
      },
      {
        dental_supplier_id: { _eq: $user_id }
      },
      {
        dental_professional_id:{_eq: $user_id }
      }
      ]}
    },
    order_by: { created_at: desc },
    limit: $limit,
    offset: $offset
  ){
    id
    title
    bid_starts_at
    bid_ends_at
    sku
    status
    winner_dental_practice_id
    winner_dental_supplier_id
    winner_dental_professional_id
    bid_price
    second_hand_supplies_bids(where:{
      _or: [
        {
          dental_practice_id: {_eq: $user_id }
        },
        {
          dental_supplier_id: { _eq: $user_id }
        },
        {
          dental_professional_id:{_eq: $user_id }
        }
      ]
    },
    order_by: {
      created_at: desc
    }){
      id
      dental_practice_id
      dental_practice{
        id
        name
      }
      dental_supplier_id
      dental_supplier{
        id
        name
      }
      dental_professional_id
      dental_professional{
        id
        name
      }
      price
      message
      created_at
    }
  }
}`;

const secondHandSuppliesAggregateQuery = gql`query second_hand_supplies_aggregate(
  $user_id:uuid!,
  $limit: Int,
  $offset: Int){
  second_hand_supplies_aggregate(
    where:{
      second_hand_supplies_bids :{
      _or: [
      {
        dental_practice_id: {_eq: $user_id }
      },
      {
        dental_supplier_id: { _eq: $user_id }
      },
      {
        dental_professional_id:{_eq: $user_id }
      }
      ]}
    },
    limit: $limit,
    offset: $offset
  ){
    aggregate{
      count
    }
  }
}`;

@Injectable({
  providedIn: 'root'
})
export class GetSecondHandSuppliesBidsService {

  /* ------------------------------- Constructor ------------------------------ */
  constructor(
  private apollo: Apollo,
  private loginService: LoginService) { }

  /* ---------------------- Get Second Hand Supplies Bids --------------------- */
  getSecondHandSuppliesBids(filter: any){
    const loginData = this.loginService.getLoginData();
    return combineLatest([
      this.apollo.use('external').query({
        query: secondHandSuppliesQuery,
        variables: {
          user_id: loginData.id,
          limit: filter.limit,
          offset: filter.offset
        }
      }).pipe(pluck('data','second_hand_supplies')),
      this.apollo.use('external').query({
        query: secondHandSuppliesAggregateQuery,
        variables: {
          user_id: loginData.id
        }
      }).pipe(pluck('data', 'second_hand_supplies_aggregate', 'aggregate', 'count'))
    ])
  }
}
